import axios from "axios";
import { Langue } from "../../Models/Message/MessageModels"
import { errorService } from "../Error/ErrorService";
import { URL_MIDIS, URLAPI } from "../../Setting";
export function LangueService(){
    return{
        async getLanguesFromURLS(urls:string[], token:string){
            let langues:Langue[]=[]
            if(urls.length>0){
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                        });
                        const data = response.data['hydra:member'];

                        if(data.length>0){
                            langues.push({
                                id:data[0]['id'],
                                nom:data[0]['nom'],
                                abreviation:data[0]['abreviation'],
                            })
                        }

                    } catch (error) {
                        errorService().handleError('Erreur obtention langues messages', error);
                        return [];
                    }
                }
            }
            return langues;
        },

        async getLangues(token:string){
            let langues:Langue[]=[];
            try {
                const response = await axios.get(`${URLAPI+'langues'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                for(const element of data){
                    langues.push({
                        id:element['id'],
                        '@id':element['@id'],
                        nom:element['nom'],
                        abreviation:element['abreviation']
                    })
                }
            } catch (error) {
                errorService().handleError('Erreur obtention langues', error);
                return [];
            }
            return langues;
        }
    }
}